import React from 'react';
import { ChevronRight } from 'lucide-react';
export const HeroSection = () => {
  return <section className="w-full bg-pink-50 px-5 py-10" data-id="element-133">
      <div className="max-w-md mx-auto" data-id="element-134">
        <h1 className="text-3xl font-bold text-pink-900 mb-6 leading-tight text-center" data-id="element-135">
          I Thought Dryness Was Just Part of Getting Older. It Wasn't.
        </h1>
        <div className="flex flex-col items-center mb-8" data-id="element-136">
          <div className="w-full max-w-[480px] h-auto mb-8 bg-white rounded-xl shadow-sm flex items-center justify-center overflow-hidden" data-id="element-137">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/19mbxUhyjV4zwPF5wTiWoz/HERO_PRODUCT_IMAGE.jpg" alt="Nuora Feminine Balance Gummies Package" className="w-full h-auto object-cover" data-id="element-138" />
          </div>
          <div className="grid grid-cols-2 gap-4 w-full" data-id="element-139">
            <BenefitItem text="Restores Natural Moisture & Lubrication" data-id="element-140" />
            <BenefitItem text="Soothes Irritation & Discomfort" data-id="element-141" />
            <BenefitItem text="Balances Intimate pH" data-id="element-142" />
            <BenefitItem text="Encourages Spontaneity & Confidence" data-id="element-143" />
          </div>
        </div>
        <p className="text-lg font-semibold text-gray-800 mb-8 leading-relaxed" data-id="element-144">
          How Thousands of Women Are Reversing Years of Vaginal Dryness &
          Discomfort—Without Messy Creams or Hormones.
        </p>
        <a href="https://mynuora.com/products/feminine-balance-gummies-1" target="_blank" rel="noopener noreferrer" data-id="element-145">
          <button className="flex items-center justify-center bg-pink-600 hover:bg-pink-700 transition-colors text-white font-bold py-4 px-6 rounded-full w-full shadow-md" data-id="element-146">
            LEARN MORE <ChevronRight className="ml-2 h-5 w-5" data-id="element-147" />
          </button>
        </a>
      </div>
    </section>;
};
const BenefitItem = ({
  text
}: {
  text: string;
}) => {
  return <div className="bg-white rounded-xl p-3.5 shadow-sm border border-pink-100 flex items-center h-full" data-id="element-148">
      <div className="w-6 h-6 bg-pink-100 rounded-full flex items-center justify-center mr-2.5 flex-shrink-0" data-id="element-149">
        <div className="w-3 h-3 bg-pink-500 rounded-full" data-id="element-150"></div>
      </div>
      <p className="text-sm font-medium text-gray-800" data-id="element-151">{text}</p>
    </div>;
};